import moment from "moment-timezone";
import { PrintLayoutMetaData } from "./PrintLayout";
import styles from "./PrintFooter.module.scss";

interface PrintFooterProps {
  metaData: PrintLayoutMetaData;
}

const PrintFooter = ({ metaData }: PrintFooterProps) => {
  const { orchid_pro, sign_timestamp } = metaData;
  if (!orchid_pro || !sign_timestamp) {
    return null;
  }

  const proFullName = `${orchid_pro.first_name} ${orchid_pro.last_name}`;
  const signedDateFormatted = moment(sign_timestamp).format(
    "MMMM D, YYYY h:mm a",
  );

  const licenses = (orchid_pro.licenses ?? []).map(
    ({ type, license_number }) => `${type ?? ""} #${license_number ?? ""}`,
  );

  return (
    <div className={styles.container}>
      <div className={styles.signature}>{proFullName}</div>
      <div>Electronically signed by {proFullName}</div>
      {licenses.map((license) => (
        <div key={license}>{license}</div>
      ))}
      <div className={styles.date}>{signedDateFormatted}</div>
    </div>
  );
};

export default PrintFooter;
